export const PROJECT_FILE_TYPE = {
  ORDER: 1,
  PROPOSAL: 2,
} as const;
export type PROJECT_FILE_TYPE = typeof PROJECT_FILE_TYPE;
export type A_PROJECT_FILE_TYPE = PROJECT_FILE_TYPE[keyof PROJECT_FILE_TYPE];
